import * as styles from "./ParagraphVideo.module.scss";

import { graphql } from "gatsby";
import React from "react";
import type { imgResolution } from "react-lite-youtube-embed";
import YouTubeLite from "../../../components/YouTubeLite/YouTubeLite";
import WrappedSection from "../../WrappedSection/WrappedSection";

export interface ParagraphVideoProps {
	heading?: string;
	jumpLinksTitle?: string;
	bodyHtmlText?: string;
	videoId: string;
	poster?: imgResolution;
}

export const getParagraphVideoProps = ({
	field_heading,
	field_jump_links_title,
	field_text,
	poster,
	relationships: {
		field_video: { field_video_id },
	},
}: Queries.ParagraphVideoDataFragment): ParagraphVideoProps => ({
	heading: field_heading,
	jumpLinksTitle: field_jump_links_title,
	bodyHtmlText: field_text?.value,
	videoId: field_video_id,
	poster: (poster as imgResolution) || "maxresdefault",
});

export const ParagraphVideo: React.FC<ParagraphVideoProps> = ({
	heading,
	jumpLinksTitle,
	bodyHtmlText,
	videoId,
	poster,
}) => {
	return (
		<WrappedSection sectionName="ParagraphVideo">
			{heading && (
				<header className={styles.videoheading}>
					{jumpLinksTitle ? (
						<h2 className={styles.heading} data-jumplinkstitle={jumpLinksTitle}>
							{heading}
						</h2>
					) : (
						<h2 className={styles.heading}>{heading}</h2>
					)}
				</header>
			)}
			<figure className={styles.paragraphvideoinner}>
				<YouTubeLite
					title={heading ? `${heading} video` : "Content video"}
					youtubeId={videoId}
					poster={poster}
				/>
				{bodyHtmlText && (
					<figcaption
						className={styles.videotext}
						// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
						dangerouslySetInnerHTML={{
							__html: bodyHtmlText,
						}}
					/>
				)}
			</figure>
		</WrappedSection>
	);
};

export default ParagraphVideo;

export const fragment = graphql`
    fragment ParagraphVideoData on paragraph__video {
        __typename
        id
        field_heading
		field_jump_links_title
        field_text {
            value
        }
		poster
        relationships {
            field_video {
                ...MediaVideoData
            }
        }
    }

    fragment MediaVideoData on media__remote_video {
        id
        name
        field_video_id
    }
`;
